document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(TextPlugin);

    function typewriterEffect(element) {
        const tl = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.5
        });

        const words = element.dataset.words.split(',');
        let currentLength = 0;

        words.forEach((word, index) => {
            // Задаем длину
            let currentLength = parseInt(element.dataset.length || 0) 
            if(word.length > currentLength) {
                element.style.minWidth=`${word.length}ch`
            }

            // Печатаем текст
            tl.to(element, {
                duration: word.length * 0.1,
                text: word,
                ease: 'none'
            });

            // Пауза после напечатания
            tl.to({}, {
                duration: 1
            });

            // Стираем текст
            tl.to(element, {
                duration: word.length * 0.05,
                text: '',
                ease: 'none'
            });
        });

        return tl;
    }

    const elementList = document.querySelectorAll('.typewriter');
    if (elementList.length > 0) {
        elementList.forEach(element => {
            typewriterEffect(element);
        })
    }
});